import downloadFlow from "core/modals/download-flow-modal";
import iconShare from "core/modals/icon-share-modal";
import auth from "components/auth/auth-modal";

export const DOWNLOAD_FLOW = downloadFlow;
export const ICON_SHARE = iconShare;
export const AUTH = auth;

export const modalTypes = {
    DOWNLOAD_FLOW: "DOWNLOAD_FLOW",
    ICON_SHARE: "ICON_SHARE",
    AUTH: "AUTH"
};
